import {AvConduction, avConductionLabels} from "../../ecg-preanalysis-data/ecg-preanalysis-data.component";

const AVB_SUFFIX = " AVB";

export function generateAvConductionsBlobText(avConductions: AvConduction[], otherAvbLabel?: string): string {
  if (avConductions.length === 0) {
    return "";
  }

  const avbConductions = avConductions.filter(ac => avConductionLabels[ac].includes(AVB_SUFFIX));
  if (avbConductions.length === 0) {
    return avConductions.map(ac => avConductionLabels[ac]).join(", ");
  }

  const labels = avConductions.map(ac => ac === "_otherAvb" ? otherAvbLabel!! : avConductionLabels[ac].replace(AVB_SUFFIX, ""));
  return labels.join(", ") + AVB_SUFFIX;
}
